export default __webpack_public_path__ + "static/media/SWT1960.34I-41628_-24895_0.dda6df80.jpg";